import { render, staticRenderFns } from "./Aushome.vue?vue&type=template&id=1952a37e&scoped=true"
import script from "./Aushome.vue?vue&type=script&lang=js"
export * from "./Aushome.vue?vue&type=script&lang=js"
import style0 from "./Aushome.vue?vue&type=style&index=0&id=1952a37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952a37e",
  null
  
)

export default component.exports